/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Knp_Lookup_Save_Changes_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to save some changes: {message}" |
*
* @param {Knp_Lookup_Save_Changes_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_save_changes_failed_toast = /** @type {((inputs: Knp_Lookup_Save_Changes_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Save_Changes_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'enregistrement de certaines modifications : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Einige Änderungen konnten nicht gespeichert werden: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile salvare alcune modifiche: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось сохранить некоторые изменения: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudieron guardar algunos cambios: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`部分更改保存失败：${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`一部の変更を保存できませんでした: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`कुछ परिवर्तन सहेजने में विफल: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao salvar algumas alterações: ${i?.message}`)
	return /** @type {LocalizedString} */ (`Failed to save some changes: ${i?.message}`)
});